define ['./email.css'], () ->
  (RentappService, $state, $filter) ->
    restrict: "E"
    template: require("./email.jade")
    scope: {field: "=", mode: "@", index: "=", stage: "="}
    link: (scope, element, attrs) ->
      if scope.field.required and scope.mode == 'edit'
        scope.field_label = "#{scope.field.label}<span>&nbsp;*</span>"
      else
        scope.field_label = scope.field.label



// WEBPACK FOOTER //
// ./directives/freeforms/email/email.coffee